// ─────────────────────────────────────────────────────────────────────────────
// i18n/locales/en.ts – English
// ─────────────────────────────────────────────────────────────────────────────
export default {
  lang: { de: 'Deutsch', fr: 'Français', it: 'Italiano', en: 'English', es: 'Español', pt: 'Português' },

  nav: {
    // Menuepunkt der Uebersichtsseite (T-M41.3) — eigener Schluessel neben
    // `nav.dashboard`, das zwei andere Stellen beschriftet.
    overview:     'Overview',
    dashboard:    'Dashboard',
    jobs:         'Print Jobs',
    fleet:        'Fleet',
    printers:     'Printers',
    schankanlage: 'Beverage System',
    printserver:  'Print Server',
    settings:     'Settings',
    users:        'Users',
    company:      'Company',
    locations:    'Locations',
    smtp:         'E-Mail SMTP',
    api:          'API',
    switchCompany:'Switch Company',
    selectCompany:'Select Company',
    logout:       'Log Out',
  },

  common: {
    save:          'Save',
    saving:        'Saving …',
    cancel:        'Cancel',
    delete:        'Delete',
    deleting:      'Deleting …',
    edit:          'Edit',
    add:           'Add',
    back:          'Back',
    loading:       'Loading …',
    search:        'Search …',
    yes:           'Yes',
    no:            'No',
    confirm:       'Confirm',
    confirmDelete: 'Really delete?',
    cannotUndo:    'This action cannot be undone.',
    new:           'New',
    optional:      '(optional)',
    unknown:       '—',
    active:        'Active',
    inactive:      'Inactive',
    enabled:       'Enabled',
    disabled:      'Disabled',
    seconds:       'sec.',
    minutes:       'min.',
    noData:        'No data available.',
    close:         'Close',
    remove:        'Remove',
    copy:          'Copy',
    copied:        'Copied!',
    change:        'Change',
    send:          'Send',
    sending:       'Sending …',
    processing:    'Processing …',
    show:          'Show',
    hide:          'Hide',
    yesDelete:     'Yes, delete',
    yesRemove:     'Yes, remove',
    note:          'Note',
    error:         'Error',
    version:       'Version',
    // Kennzahl, die NICHT serverseitig gezaehlt ist: Untergrenze (REQ-OPS-034)
    count: {
      atLeast:      'At least {count}',
      atLeastShort: '≥ {count}',
      atLeastHint:  'Derived from the loaded list – at least this many, possibly more.',
    },
    // Blaettern statt Kuerzen (REQ-OPS-032/033, T-M8.19b) — die zwei Texte,
    // die in JEDER geblaetterten Liste gleich lauten.
    pagination: {
      liveFirstPageOnly: 'Only the first page is updated live.',
      loadFailed:        'Loading more failed.',
    },
  },

  status: {
    online:   'Online',
    offline:  'Offline',
    printing: 'Printing',
    error:    'Error',
    ready:    'Ready',
    pending:  'Pending',
    done:     'Done',
    // Delivery status `completed` (REQ-DM-040) — see de.ts.
    completed: 'Delivered',
    failed:   'Failed',
    expired:  'Expired',
  },

  role: {
    admin:    'Administrator',
    user:     'User',
  },

  auth: {
    email:              'E-Mail Address',
    password:           'Password',
    passwordNew:        'New Password',
    passwordNewLabel:   'New Password *',
    passwordConfirm:    'Confirm Password',
    passwordConfirmLabel:'Confirm Password *',
    passwordMinHint:    'At least 8 characters',
    passwordRepeat:     'Repeat Password',
    passwordMismatch:   'Passwords do not match.',
    passwordTooWeak:    'The password is too weak (at least 8 characters).',
    passwordSave:       'Save Password',
    passwordSaved:      'Password saved!',
    passwordSavedHint:  'Your password has been changed successfully. You will be redirected automatically …',
    toDashboard:        'Go to Dashboard',
    linkInvalid:        'Link invalid',
    linkInvalidHint:    'This link has expired or has already been used. Please request a new link.',
    toLogin:            'Go to Login',
    setNewPassword:     'Set New Password',
    setNewPasswordHint: 'Enter your new password for',
    welcomeBack:        'Welcome back',
    welcomeHint:        'Sign in with your account.',
    login:              'Log In',
    loggingIn:          'Logging in …',
    logout:             'Log Out',
    forgotPassword:     'Forgot password?',
    resetPassword:      'Reset Password',
    resetSent:          'E-Mail sent. Please check your inbox.',
    backToLogin:        'Back to Login',
    sessionExpired:     'Your session has expired (12 hours). Please sign in again.',
    footer:             'Payfix AG · Print Management System · v1.0',
    strength: {
      weak:      'Weak',
      medium:    'Medium',
      strong:    'Strong',
      veryStrong:'Very Strong',
    },
    errors: {
      invalidEmail:    'Invalid e-mail address.',
      wrongPassword:   'Wrong password.',
      userNotFound:    'No user found with this e-mail.',
      tooManyRequests: 'Too many attempts. Please wait.',
      generic:         'Login failed. Please try again.',
      occurred:        'An error occurred.',
    },
  },

  invitation: {
    title:        'Accept invitation',
    subtitle:     'Set your password to complete your account.',
    submit:       'Create account',
    working:      'Creating account …',
    successTitle: 'Your account is ready',
    successHint:  'You are being signed in and redirected …',
    errInvalid:   'This invitation is not valid. Please request a new invitation.',
    errExpired:   'This invitation has expired. Please request a new invitation.',
    errExists:    'An account already exists for this address. Please sign in with your existing password.',
    errFailed:    'The invitation could not be accepted. Nothing was created; please try again.',
  },

  bootstrap: {
    errorTitle: 'Startup failed',
    errorHint:  'The sign-in could not be completed. Please try again or sign in again.',
    errorHintNoProfile: 'There is no user profile for this account. Please contact your administrator.',
    errorCode:  'Error code: {code}',
    retry:      'Try again',
    reLogin:    'Sign in again',
  },

  // T-M21.5 / REQ-OPS-054: the notice NAMES the affected areas and shows NO
  // timestamp — the time of the last snapshot received is not tracked anywhere.
  liveVerbindung: {
    title:     'Live updates interrupted',
    areas:     'No longer live: {areas}',
    hint:      'The data shown is from the last update received and may be out of date. It will only be updated again once the connection has been re-established.',
    reconnect: 'Reconnect',
    quiet:     'Connection interrupted: {areas}',
    area: {
      jobs:         'Print Jobs',
      printers:     'Printers',
      printservers: 'Print Servers',
      companies:    'Companies',
      locations:    'Locations',
      registers:    'Registers',
      users:        'Users',
      apiTokens:    'API Tokens',
    },
  },

  fleet: {
    title:          'Fleet',
    subtitle:       'Print servers by location – live status, version and queues.',
    empty:          'No print servers yet',
    emptyHint:      'As soon as a print server is set up, it appears here.',
    noLocation:     'No location',
    noServers:      'No print servers at this location',
    noPrinters:     'No printers',
    unassignedPrinters: {
      text:   'One printer is waiting for assignment | {count} printers are waiting for assignment',
      hint:   'These printers were created via the interface and have no print server assigned. They appear in no group of this view and will only accept jobs once a print server has been assigned.',
      action: 'Assign in the printer list',
    },
    locationOffline:'Location offline',
    serverCount:    '{n} print servers',
    version:        'Version',
    versionUnknown: 'Unknown',
    versionOutlier: 'Outlier',
    versionOutlierHint: 'Differs from fleet version v{version}.',
    lastPing:       'Last heartbeat',
    pending:        '{n} pending',
    queueEmpty:     'No pending jobs',
    pendingAtLeast: 'At least {n} pending',
    queueUnknown:   'Queue unknown',
    queueUnknownHint: 'The queue could not be counted. That does not mean it is empty.',
    queueHeldHeading: 'On hold ({n})',
    queueHeldHint:    'These jobs are printed only once the kitchen marks them as ready for pickup. That is why they have no queue position.',
    queueNoneWaiting: 'Nothing is waiting for the printer',
    time: {
      never:        'Never',
      justNow:      'Just now',
      minutes:      '{n} min ago',
      hours:        '{n} h ago',
      days:         '{n} days ago',
    },
  },

  dashboard: {
    title:          'Dashboard',
    welcome:        'Welcome',
    totalJobs:      'Jobs total',
    totalPrinters:  'Total Printers',
    onlinePrinters: 'Printers Online',
    printservers:   'Print Servers',
    recentJobs:     'Recent Print Jobs',
    noJobs:         'No print jobs available.',
    heldJobs:       'On hold',
    heldJobsHint:   'These order tickets are printed only once the kitchen marks them as ready for pickup. They are not waiting for the printer and are not a backlog.',
  },

  printers: {
    title:         'Printers',
    subtitle:      'All connected printers of this company',
    add:           'Add Printer',
    empty:         'No printers added yet',
    emptyHint:     'Add the first printer for this company.',
    number:        'No.',
    name:          'Name',
    type:          'Type',
    printserver:   'Print Server',
    ipAddress:     'IP Address',
    pendingBons:   'Open Receipts',
    deleteTitle:   'Delete Printer?',
    deleteConfirm: 'Do you really want to delete {name}?',
    new:           'New Printer',
    edit:          'Edit',
    openKitchen:      'Open Kitchen TV',
    openAbholscreen:  'Open pickup screen',
    openFastline:     'Open Fastline',
    // BERICHTIGT AM 2026-08-17 (T-M8.19b, REQ-OPS-032 neu gefasst): der
    // Schluessel bleibt, sein Wortlaut wird berichtigt statt geloescht. Bis
    // dahin sagte er „die Liste ist gekuerzt, weitere Drucker sind hier nicht
    // sichtbar" — eine Sackgasse. Die 100 sind ab jetzt die SEITENgroesse.
    limitReached:     'There are more printers of this company: one page of {count} entries is loaded — load more.',
    loadMore:         'Load {count} more printers',
    // Kurzform fuer das Nachladen IM Auswahlkontext (Drucker-Dropdown der
    // Auftragsliste): dort ist kein Platz fuer die Seitengroesse.
    loadMoreShort:    'Load more printers …',
    loadedCount:      '{count} printers loaded',
    endOfList:        'End of list – all printers are loaded.',
    sections: {
      basic:       'Basic Data',
      abholscreen: 'Pickup Screen Settings',
      kitchenTv:   'Kitchen TV Settings',
      alarm:       'Alerts',
      status:      'Status',
      screenAccess: 'Display key',
    },
    fields: {
      outputType:        'Output type',
      outputPrint:       'Printer',
      outputKitchenTv:   'Kitchen TV / Screen',
      outputPrintHint:   'Physical ESC/POS printer with address and model type.',
      outputKitchenTvHint: 'Screen channel without print server, address or model type.',
      port:              'Port',
      abholscreenEnabled: 'Pickup screen enabled',
      abholscreenEnabledHint: 'Shows ready order numbers on the pickup screen.',
      displayDurationHint: 'Display duration of ready orders, 5 to 600 seconds (default 60 seconds).',
      autoCompleteDisabled:     'Disable automatic completion',
      autoCompleteDisabledHint: 'Ready orders stay on screen until they are completed by hand — the display duration no longer completes them. Four hours after they arrive they are completed automatically anyway; that cleanup cannot be switched off.',
      maxItems:          'Max. numbers shown',
      maxItemsUnit:      'numbers',
      maxItemsHint:      'Upper limit of numbers shown simultaneously (0 = unlimited).',
      screenKeyHint:       'The display key signs a screen (Kitchen TV, pickup screen, Fastline) in. Only the hash is stored; the plaintext cannot be retrieved afterwards.',
      screenKeySaveFirst:  'Please save the channel first, then you can set a display key.',
      screenKeySet:        'Display key set',
      screenKeyNotSet:     'No display key set',
      screenKeyPlaceholder:'Enter or generate key',
      screenKeyGenerate:   'Generate',
      screenKeySave:       'Set key',
      screenKeyRotate:     'Rotate key',
      screenKeyOnce:       'This key is shown only ONCE. Please note it down securely now.',
      screenKeyRequired:        'Require display key',
      screenKeyRequiredHint:    'A screen signs in to this channel with the display key. Without it, it gets no access.',
      screenKeyRequiredOffHint: 'This channel is open without a display key: anyone who knows the screen address reads this channel’s orders and sets their work status. Access stays limited to this channel and this company.',
      screenKeyRequiredOffPrintHint: 'On this channel that also triggers a printout: setting an order to «Ready for pickup» releases the held work receipt, and it is printed.',
      alarmEnabled:      'Alerts enabled',
      alarmEnabledHint:  'Notifies on printer problems (offline, error).',
      alarmMuted:        'Mute completely',
      alarmMutedHint:    'Suppresses all alerts for this printer.',
      alarmStages:       'Alerted stages',
      stage_offline:     'Offline',
      stage_paperLow:    'Paper low',
      stage_error:       'Error',
      stage_coverOpen:   'Cover open',
      // Stufe Papierende (T-M42.3, REQ-PS-023c) und Kennzeichnung unwirksamer
      // Stufen je Modelltyp (REQ-PS-023a Praez. 1 (a) / Praez. 3).
      stage_paperOut:    'Out of paper',
      stageIneffective:  'ineffective',
      stageIneffectiveTitle: 'Model type {model} does not report this condition. The stage can be set but never triggers an alert on this printer.',
      stagesIneffectiveHint: 'Stages marked «ineffective» are not reported by model type {model}: they can be set but never trigger an alert on this printer.',
      // T-M42.10 Teil (b): die gesetzten Stufen wuerden mangels Einrichtung
      // am Mandanten nie versendet (Regel: utils/alarmEinrichtung.ts).
      alarmNotSetUpTypeDisabled: 'Alarms not set up: «Printer fault» is switched off in the company\'s alarm center. The stages set here are never sent.',
      alarmNotSetUpNoRecipients: 'Alarms not set up: no recipient is configured in the company\'s alarm center. The stages set here are never sent.',
      printerId:         'Printer ID',
      printerIdPlaceholder: 'e.g. 3324',
      printerIdHint:     'The printer ID from the Payfix portal — exactly the value the POS sends as printer_id. Not a freely chosen number: without the correct ID no receipt reaches this channel.',
      designation:       'Name',
      printerType:       'Printer Type',
      printerServer:     'Print Server',
      ipAddress:         'IP Address',
      sameAddressHint:   'Same address as «{name}». Both channels print one after another on the same device.',
      company:           'Company',
      range:             'From / To',
      rangeFrom:         'From',
      rangeTo:           'To',
      tableRangesHint:   'If ranges are set, this channel only receives work slips and receipts whose table number falls within one of the ranges. This also applies to Kitchen TV, pickup screen and Fastline. Documents without a table number – including end-of-day reports and staff settlements – always reach this channel. If no range is set, it receives everything.',
      qrCode:            'Print QR Code',
      qrCodeHint:        'Adds a QR code to the receipt. It is also the precondition for jobs to appear on this printer\'s pickup screen.',
      qrCodeOffByKitchenTv: 'The receipt QR code stays off while the Kitchen TV view is switched on — the two are never active at the same time on one printer. Switching it on here switches the Kitchen TV view off.',
      qrCodeOffByU220: 'The TM-U220 does not print QR codes. The switch is locked on this model and has no effect.',
      showName:          'Show Printer Name',
      colorWorking:      'Color Working',
      colorReady:        'Color Ready for Pickup',
      displayDuration:   'Display Duration',
      preview:           'Preview',
      kitchenTvEnabled:  'Kitchen TV',
      kitchenTvEnabledHint: 'Also shows this printer\'s orders on a Kitchen TV screen. The printer remains a full printer and keeps printing. Switching it on turns the receipt QR code off.',
      autoStartTimer:    'Start Timer Automatically',
      autoStartTimerHint:'Starts the timer automatically when an order is received',
      disablePrintingWhenKitchenTv:     'Do not print work slips',
      disablePrintingWhenKitchenTvHint: 'Work slips of this channel are no longer printed, they are only shown on the Kitchen TV. They count as delivered immediately and appear in the job list marked «delivered without printing». Customer receipts are still printed. On a screen-only channel the setting has no effect, because nothing is ever printed there.',
      fastline:          'Fastline',
      rangeRemove:       'Remove range {n}',
      abholscreenUrl:    'Pickup screen URL',
      kitchenTvUrl:      'Kitchen TV URL',
      kitchenTvUrlLight: 'Kitchen TV Light URL',
      fastlineUrl:       'Fastline URL',
    },
    // Der aktive Bildschirm-Modus, angezeigt statt eingestellt
    // (REQ-SC-106 (2), T-M25.5). Die drei Modusnamen sind Produktnamen und
    // stehen in allen sechs Sprachen gleich; die Feldwerte bleiben
    // technisch-englisch (REQ-OV-002, REQ-DM-068 (1)).
    screenMode: {
      label:    'Active mode',
      hint:     'Shows which screen currently runs this channel. The mode is taken over on the screen itself, not here: whoever opens one of the three addresses confirms the switch there and thereby deactivates the previous mode.',
      mode_normal:   'Kitchen TV normal',
      mode_light:    'Kitchen TV Light',
      mode_fastline: 'Fastline',
      mode_none:     'no mode active',
    },
    kitchenTvInactive: 'Kitchen TV is disabled. Enable it above to adjust the settings.',
    kitchenTvAlwaysOn: 'This channel is a screen channel: the Kitchen TV view always runs here and cannot be switched off.',
    // Druckerzustand: grob (status.*) plus feine Kennungen (REQ-PS-020a/021).
    // Werte bleiben technisch-englisch in Firestore, hier nur die Anzeige.
    status: {
      title:       'Current status',
      noDetail:    'No issues',
      updatedAt:     'Status unchanged since',
      updatedAtHint: 'The time of the last status CHANGE — not the time of the last report. The print server writes this value only when the status changes; a permanently healthy printer therefore shows an old timestamp here.',
      never:         'No status reported yet',
      stale: {
        withAge:    'Outdated — last reported {age} ago',
        unknownAge: 'Outdated — age unknown',
        age: {
          lessThanMinute: 'less than a minute',
          minute:  'a minute',
          minutes: '{n} minutes',
          hour:    'an hour',
          hours:   '{n} hours',
          day:     'a day',
          days:    '{n} days',
        },
        reason: {
          noPrintserver: 'No print server is assigned to this printer. Only the print server writes the status — without it, the last value written stays as it is, indefinitely.',
          noPing:        'The responsible print server has not written a heartbeat yet. There is therefore no way to tell how old the status shown is.',
          serverOffline: 'The responsible print server is offline. It can no longer report this printer\'s status; what is shown is the last value written.',
          pingTooOld:    'The last heartbeat of the responsible print server is older than the limit of 90 seconds (three times the 30-second interval). The status shown is the last one written and may no longer be true.',
        },
      },
      sourceLabel: 'Source',
      levelLabel:  'Detail level',
      levelHint:   'How detailed this printer model can report.',
      detail: {
        offline:     'Unreachable',
        coverOpen:   'Cover open',
        paperOut:    'Out of paper',
        cutterError: 'Cutter error',
        error:       'Printer error',
        notResponding: 'Not responding',
        paperLow:    'Paper low',
      },
      source: {
        asb:        'Reported by the printer',
        poll:       'Active poll',
        jobResult:  'Derived from the print result',
        connection: 'Connection lost',
      },
      level: {
        full:  'Full',
        basic: 'Limited',
        none:  'No status feedback',
      },
    },
    archived:     'Archived',
    archivedHint: 'Archived printers no longer accept jobs.',
    incomplete:     'Incomplete',
    // Corrected on 2026-09-07 (T-M33.3, REQ-DM-072 (h)): jobs for a print
    // channel without a resolvable print server are rejected with 400 since
    // T-M8.3 — they are not accepted and left undelivered.
    incompleteHint: 'This printer has no target print server. It only accepts jobs once a print server has been assigned; until then jobs sent to it are rejected.',
    filter: {
      all:            'All',
      unassigned:     'Without print server ({count})',
      noneUnassigned: 'Every printer has a print server assigned.',
    },
    quickAssign: {
      label:       'Assign print server',
      placeholder: 'Assign print server …',
      saving:      'Assigning …',
      failed:      'The assignment could not be saved. Please try again.',
      noServers:   'No print server exists for this company.',
    },
    unassignedNotice: {
      title: 'No print server assigned',
      body:  'This printer was created via the interface and will only accept jobs once a print server has been assigned. Select a print server below and save.',
    },
    validation: {
      nameRequired:         'Please enter a designation.',
      numberRequired:       'Please enter the printer ID from the Payfix portal.',
      // NEW 2026-09-18 (T-M41.8, REQ-DM-036 Praez. 4 (ix)).
      payfixPrinterIdInvalid: 'This printer ID cannot be saved. The slash, the values «.» and «..», identifiers of the form «__…__» and more than 1500 bytes are not permitted. Please enter the identifier configured for this printer in the Payfix portal.',
      payfixPrinterIdTaken: 'Printer ID {id} is already assigned to printer «{name}» of company «{company}». Each ID may occur only once — otherwise the receipt ends up on the wrong channel. Please enter the ID stored for this printer in the Payfix portal.',
      payfixPrinterIdTakenOtherCompany: 'Printer ID {id} is already assigned to printer «{name}» of company «{company}» — that is outside the company selected here, and you cannot view that printer. Each ID may occur only once — otherwise the receipt ends up on the wrong channel. Please contact those responsible for «{company}» or enter the ID stored for this printer in the Payfix portal.',
      payfixPrinterIdTakenOtherCompanyUnnamed: 'Printer ID {id} is already assigned in another company. Which company that is cannot be shown here — it lies outside your access. Each ID may occur only once — otherwise the receipt ends up on the wrong channel. Please contact Payfix support or enter the ID stored for this printer in the Payfix portal.',
      payfixPrinterIdTakenOrphaned: 'Printer ID {id} is already assigned to printer «{name}», and that printer is not assigned to any readable company — an orphaned ID. It therefore remains taken system-wide although no company can be found for it. Please enter a different ID stored in the Payfix portal and report the orphaned ID to operations.',
      payfixPrinterIdTakenOrphanedUnnamed: 'Printer ID {id} is already taken, and the printer holding it is not assigned to any readable company — an orphaned ID. It therefore remains taken system-wide although no company can be found for it. Please enter a different ID stored in the Payfix portal and report the orphaned ID to operations.',
      payfixPrinterIdCheckFailed: 'The printer ID could not be checked — the lookup is currently unreachable. Nothing was saved. Please try again in a moment.',
      printserverRequired:  'Please select a print server. Without a target server the job is not delivered.',
      modelTypeRequired:    'Please select a model type (Standard, U220 or Sunmi).',
      ipAddressRequired:    'Please enter the printer\'s IP address or host name. Without an address the print server can neither reach it nor query its state.',
      printserverForbidden: 'A screen channel must not have a print server.',
    },
    warnings: {
      abholscreenNeedsQrCode:       'The pickup screen stays empty on this printer: without receipt QR printing no job appears on it. The printed receipt QR is the guest\'s pickup proof. Enabling receipt QR printing later only affects newly incoming jobs — jobs already created do not appear retroactively.',
      abholscreenNeedsQrCodeAction: 'Enable receipt QR printing',
      abholscreenNeedsKitchenTvAction: 'Switch on the Kitchen TV view',
      abholscreenNeedsQrCodeSave:   'Pickup screen active, receipt QR printing off: this pickup screen stays empty. Click Save again to store the setting anyway.',
    },
    notices: {
      displayDurationDisabled:     'No effect: automatic completion is off',
      displayDurationDisabledHint: 'While automatic completion is switched off, nothing expires after this duration. The value stays stored and takes effect again as soon as automatic completion is switched back on.',
    },
  },

  printserver: {
    title:              'Print Server',
    subtitle:           'Connected print servers of this company',
    subtitleAllCompanies: 'Connected print servers of all companies',
    subtitleOwnCompanies: 'Connected print servers of your companies',
    add:                'Add Print Server',
    empty:              'No print servers added yet',
    emptyHint:          'Add the first print server.',
    name:               'Name',
    uuid:               'UUID',
    uuidCopy:           'Copy UUID',
    uuidLabel:          'UUID (auto-generated)',
    uuidHint:           'A label for humans, not a configuration value: the daemon does not read the UUID. Setup uses the document ID.',
    documentId:         'Document ID',
    documentIdHint:     'The daemon reads this identifier as PRINTSERVER_ID from its .env file. It is assigned when the print server is created and cannot be changed.',
    documentIdPending:  'The identifier is created when you save.',
    ipAddress:          'IP Address',
    anydeskId:          'AnyDesk ID',
    anydeskIdMissing:   'The print server reports the AnyDesk ID at startup. If it is missing, the device is either still running older software that does not report it, or AnyDesk is not installed there or the ID cannot be read.',
    company:            'Company',
    status:             'Status',
    connectedSince:     'Connected since',
    lastContact:        'Last Contact',
    connectedMins:      'Connected for {n} min.',
    connectedHrs:       'Connected for {h} h {m} min.',
    lessThan1Min:       '< 1 min.',
    lastContactSec:     '{n} sec. ago',
    lastContactMin:     '{n} min. ago',
    lastContactHr:      '{n} hr. ago',
    nodeVersion:        'Node.js Version',
    appVersion:         'App Version',
    printerCount:       'Connected Printers',
    printerCountValue:  '{n}',
    printerCountAtLeast:'at least {n}',
    printerCountAtLeastHint: 'The printer list is only loaded page by page ({count} per page) — this number is a lower bound. More printers may belong to this print server; load more.',
    printerCountUnknownHint: 'The printer list is not available yet. The number appears once it has loaded.',
    runtimeFieldPending:'The print server reports this field on a status change (start or stop). Devices running older software do not report it yet — the value appears after the next restart.',
    updateAvailable:    'Update available: v{v}',
    restartControl:     'Restart Control',
    restartManual:      'Manual Restart',
    restartHint:        'Sends a restart command to the Node.js application on the Raspberry Pi.',
    restartAfter:       'Restart after (minutes)',
    restartNow:         'Restart Now',
    restarting:         'Restarting …',
    // ⚠ `restartSent` ist am 2026-09-18 mit T-M41.9 in allen sechs Sprachen
    // ENTFALLEN; die Begründung steht am selben Ort in `de.ts`.
    // NEW 2026-09-18 (T-M41.9): the receipt from the live document replaces the
    // success message after the click — two timestamps, no verdict.
    restartRequested:        'Restart requested on {t}',
    restartNotAcknowledged:  'No acknowledgement from the device yet.',
    restartExecuted:         'Carried out by the device on {t}',
    restartReconnected:      'Reconnected since {t}',
    autoRestartDelayHint: 'The change takes effect the next time the launcher starts on the device — just like the restart time. 0 = no interval.',
    autoRestart:        'Automatic Restart',
    autoRestartHint:    'The app will be automatically restarted after this interval. 0 = disabled.',
    autoRestartDisabled:'Auto-restart is disabled.',
    autoRestartEnabled: 'App will be restarted every {n} minutes.',
    connectionInfo:     'Connection Info',
    connectionHint:     'The Raspberry Pi updates IP, version and status automatically via Firestore heartbeat.',
    deleteTitle:        'Delete Print Server?',
    deleteConfirm:      'Do you really want to delete {name}?',
    cannotUndoFull:     'Do you really want to delete "{name}"? This action cannot be undone.',
    new:                'New Print Server',
    stammdaten:         'Master Data',
    assignCompany:      'Assign Company',
    noCompany:          '— No Company Assigned —',
    companyHint:        'The print server will only appear for users of this company.',
    companyPreset:      'Preset',
    companySearch:      'Search company …',
    companySelect:      'Select company',
    companyNoMatch:     'No company found.',
    cascadeTitle:       'Printers lose their print server',
    cascadeText:        'Printers assigned to this print server ({count}): {names}. They lose the assignment and accept no more jobs until a print server is assigned to them.',
    cascadeConfirm:     'Remove assignment and continue',
    companyRequired:    'Please assign a company. If the print server should no longer belong to any company, delete it.',
    infoCard:           'Info',
    piSetup:            'Raspberry Pi Setup',
    piSetupHint:        'Enter this identifier in the .env file of the Raspberry Pi daemon:',
    piSetupPending:     'Save the print server first. The identifier for the .env file of the Raspberry Pi daemon will then appear here.',
    settingsTitle:      'All configured print servers – click to open',
    settingsNoCompany:  '— No Company —',
    settingsAddFirst:   'Add First Print Server',
    location:           'Location',
    noLocation:         '— No location assigned —',
    locationHint:       'Assigns the print server to a location.',
  },

  locations: {
    title:            'Locations',
    subtitle:         'All locations of this company',
    add:              'Add location',
    empty:            'No locations created yet',
    emptyHint:        'Add the first location of this company.',
    name:             'Location name',
    namePlaceholder:  'e.g. Main site Zurich',
    new:              'New location',
    edit:             'Edit',
    autoUpdate:       'Automatic update',
    autoUpdateOn:     'Active',
    paused:           'Paused',
    updateSection:    'Automatic update',
    updatePaused:     'Pause update',
    updatePausedHint: 'Suspends the automatic update of the print servers at this location.',
    updateChannel:    'Update channel',
    channelStable:    'Stable',
    channelBeta:      'Beta',
    pinnedVersion:    'Pinned version',
    pinnedVersionHint:'Leave empty for the latest version in the selected channel.',
    latest:           'Latest',
    deleteTitle:      'Delete location?',
    deleteConfirm:    'Do you really want to delete {name}?',
  },

  jobs: {
    title:          'Print Jobs',
    subtitle:       'All print jobs of this company',
    new:            'New Job',
    empty:          'No print jobs available.',
    emptyFiltered:     'None of the loaded jobs match the active filters.',
    emptyFilteredHint: 'More jobs can be loaded below.',
    id:             'Job ID',
    printer:        'Printer',
    register:       'Register',
    status:         'Status',
    createdAt:      'Created at',
    updatedAt:      'Last updated',
    payload:        'Payload',
    create:         'Create Print Job',
    send:           'Send Print Job',
    sending:        'Creating …',
    selectRegister: 'Select register …',
    payloadLabel:   'JSON Payload (Payfix format)',
    loadExample:    'Load example',
    invalidJson:    'Invalid JSON. Please check.',
    created:        'Print job created',
    sourcePayfix:   'Payfix',
    sourceDashboard:'Dashboard',
    source:          'Source',
    type:            'Type',
    typePrintjobs:   'Print jobs',
    typeReceipts:    'Receipts',
    statusAll:       'All',
    allPrinters:     'All printers',
    allPrintservers: 'All print servers',
    cashier:         'Employee',
    positions:       'Items',
    total:           'Total',
    received:        'Received',
    printed:         'Printed',
    paymentMethod:   'Payment method',
    items:           'Items',
    posName:         'Item',
    posQty:          'Quantity',
    posUnit:         'Unit price',
    posTotal:        'Total',
    subtotal:        'Subtotal',
    tax:             'VAT',
    noItems:         'No items available.',
    resend:          'Resend',
    deleteTitle:     'Delete print job?',
    deleteConfirm:   'Do you really want to delete job {id}?',
    loadMore:          'Load more jobs',
    loadingMore:       'Loading …',
    loadedCount:       '{count} jobs loaded',
    endOfList:         'End of list – all jobs are loaded.',
    loadMoreError:     'Loading more jobs failed.',
    liveFirstPageOnly: 'Only the first page updates live.',
    device:          'Device',
    deleteError:     'Deletion failed.',
    resendError:     'Resend failed. The job was not created.',
    resendNoPrintserver: 'Resend not possible: no print server is assigned to this channel (screen channels cannot be printed).',
    deliveryStatus:  'Delivery status',
    printerName: {
      idHint:         'Printer ID: {id}',
      unresolved:     'Name cannot be resolved',
      unresolvedHint: 'No channel with this ID exists in the loaded printer list – it was probably deleted. ID: {id}',
      notLoaded:      'Name not loaded',
      notLoadedHint:  'The printer list is only loaded page by page, so the name of this channel is not there yet. This does not say whether the channel still exists – load more printers. ID: {id}',
    },
    workStatus: {
      label:              'Work status',
      columnHint:         'Second, independent status dimension: only orders (work slips) carry a work status. Customer receipts carry none, which is why their field stays empty. It is shown only for channels with the kitchen TV view enabled; on all other rows the field likewise stays empty — in the job details the value remains visible there as soon as it differs from “Open”.',
      open:               'Open',
      inPreparation:      'In preparation',
      ready:              'Ready for pickup',
      done:               'Done',
      unknown:            'Unknown',
      unknownHint:        'This value is not part of the defined vocabulary.',
      notPrintedDoneHint: 'Not a contradiction: delivery and work status are two separate statements. The job never reached its destination, but it was closed operationally (automatically after four hours).',
      readOnly:           'Display only – the work status is not switched here.',
    },
    // Recorded omission on the receipt (REQ-PR-037, REQ-DM-030 addition,
    // T-M11.12).
    omitted: {
      badge:       'Receipt incomplete',
      badgeHint:   'The job was delivered, but the printer model could not execute individual commands of the receipt. The expanded job detail lists what was omitted.',
      title:       'Commands not executed',
      position:    'Position',
      opcode:      'Opcode',
      opcodeNone:  'no single command',
      reasonLabel: 'Reason',
      unknownHint: 'This value is not part of the defined vocabulary.',
      reason: {
        unsupportedByModel: 'Not supported by the printer model',
        emptyPayload:       'No payload',
        invalidParameter:   'Invalid parameter',
        unflushedBuffer:    'Line buffer not flushed',
        unknownOpcode:      'Unknown print command',
        logoUnreadable:     'Logo not printable',
        unknown:            'Unknown',
      },
      detail: {
        cut:      'Full cut',
        textline: 'Line buffer',
        unknown:  'Unknown',
      },
    },
    deliveredWithoutPrint: {
      badge:     'Delivered without printing',
      badgeHint: 'This job was deliberately not printed: the channel only shows work slips on screen. It counts as delivered on arrival and therefore carries no print time.',
      title:     'Delivered without printing',
      timeLabel: 'Delivered (without printing)',
    },
    deliveryConfirmation: {
      badge:     'Delivered without printer confirmation',
      badgeHint: 'This printer model does not report the print back; only the transmission was measured.',
    },
    // Receipt content preview (REQ-OPS-060, T-M29.3) — read only and expressly
    // NOT a print preview. No command is dropped silently (REQ-PR-020).
    belegVorschau: {
      title:               'Receipt content (preview)',
      abweichungsHinweis:  'Not a print preview: the printed receipt may differ from this. Line width, text size and images are only created in the printer.',
      u220Hinweis:         'This receipt uses the TM-U220 command language. There is no preview for it — the same command numbers mean something else there, so a display would be guessed instead of read.',
      leerHinweis:         'This receipt carries no print commands.',
      platzhalter: {
        align:           'Alignment',
        textSize:        'Text size',
        cut:             'Cut',
        qr:              'QR code',
        image:           'Image',
        textEmpty:       'Text command without content',
        unknown:         'Unknown command {opcode} at position {position}',
        unknownNoOpcode: 'Command without command number at position {position}',
      },
    },
  },

  settings: {
    title: 'Settings',

    company: {
      title:            'Companies',
      subtitle:         'All registered companies',
      eyebrow:          'Settings · Company',
      add:              'Add Company',
      empty:            'No companies added yet.',
      name:             'Company Name',
      nameLabel:        'Company Name *',
      email:            'E-Mail',
      phone:            'Phone',
      address:          'Address',
      city:             'City',
      zip:              'ZIP Code',
      country:          'Country',
      logo:             'Logo',
      description:      'Description',
      descriptionHint:  'Internal notes …',
      companyData:      'Company Data',
      bonSettings:      'Receipt Settings',
      bonLogo:          'Receipt Logo',
      bonLogoHint:      'Appears at the top of the customer receipt and the cancellation receipt, on the interim bill according to the switch below, not on closing reports and not on TM-U220 printers. PNG, JPG or SVG, max. 2 MB; scaled down to the print width and printed in black and white.',
      bonLogoDrop:      'Drop logo here or click to select',
      // T-M51.4 (REQ-DM-010a Praez. 1 (2)/(4)): Meldungen der Logo-Erfassung,
      // die Beschriftung der Druckvorschau und der Hinweis unter Schlusstext
      // und QR-Code-URL.
      bonLogoFileTooLarge:   'The file is larger than 2 MB.',
      bonLogoResultTooLarge: 'Even scaled down, the logo is too large to save. Please choose a simpler file.',
      bonLogoNotImage:       'The file could not be read as an image.',
      bonLogoPrintPreview:   'Print preview (black and white)',
      bonFooterQrHint:       'Appear at the end of the customer receipt, on the interim bill according to the switches below, not on cancellation receipts or closing reports, and not on TM-U220 printers.',
      // T-M54.5 (REQ-DM-010a Praez. 2 (4)): Kartenueberschrift und die drei
      // Schalter der Zwischenrechnung mit ihrem Hinweis.
      receiptSettings:       'Receipt Settings',
      interimReceiptLogo:    'Print logo on interim bill',
      interimReceiptFooter:  'Print closing text on interim bill',
      interimReceiptQr:      'Print QR code on interim bill',
      interimReceiptHint:    'Applies to the interim bill from the POS, on Epson and Sunmi printers, not on TM-U220 printers. Anything not entered above is not printed on the interim bill either.',
      bonFooter:        'Receipt Footer',
      qrUrl:            'QR Code URL',
      usersSection:     'Users',
      usersSubtitle:    'Users of this company and their editing rights',
      addUser:          'Add User',
      noUsers:          'No users assigned yet',
      userCol:          'User',
      emailCol:         'E-Mail',
      removeUser:       'Remove User?',
      removeUserConfirm:'Do you want to remove this user from the company?',
      existingUser:     'Existing User',
      inviteByEmail:    'Invite by E-Mail',
      userSearch:       'Search users …',
      noUsersFound:     'No users found',
      inviteSent:       'Invitation sent to {email}!',
      inviteEmailHint:  'The user will receive an e-mail with a link to set their password.',
      systemRole:       'System Role',
      roleUser:         'User',
      roleAdmin:        'Administrator',
      deleteTitle:      'Delete Company?',
      deleteConfirm:    'Do you really want to delete {name}?',
      cannotUndoFull:   'Do you really want to delete "{name}"? This action cannot be undone.',
      payfixId:         'Payfix customer ID',
      payfixIdHint:     'Assigned by Payfix and cannot be edited.',
      receiptFooter:    'Receipt footer text',
      footerPlaceholder:'Thank you for your purchase!',
      alarmCenter:      'Alarm center',
      alarmSectionSub:  'Automatic notifications when problems occur',
      emailAlarm:       'Email alarm',
      emailAlarmHint:   'Notifications by email',
      alarmWhen:        'When should an alarm be triggered?',
      triggerQueueOffline:      'Queue offline',
      triggerQueueOfflineDesc:  'Notification when the print server queue goes offline',
      triggerNotPrinted:        'Print job not printed (10 min)',
      triggerNotPrintedDesc:    'Notification when a receipt has not been printed after 10 minutes',
      triggerPrinterOffline:    'Printer fault',
      // `alarmOnPrinterOffline` traegt ALLE Drucker-Stufen, nicht nur `offline`
      // (T-M42.10); bis zum 2026-09-26 lautete der Text „Drucker Offline“.
      triggerPrinterOfflineDesc:'Notification for every alarm stage enabled on the printer (offline, error, paper low, cover open, out of paper)',
      // T-M42.10 Teil (b): Alarmierung nicht eingerichtet (utils/alarmEinrichtung.ts).
      alarmNotSetUp:             'Alarms not set up',
      alarmNotSetUpNoType:       'No alarm type is switched on. No alarm is currently sent for this company.',
      alarmNotSetUpNoRecipients: 'No recipient is configured: switch on email alarm and add at least one address. Until then, no alarm is sent for this company.',
      alarmNotSetUpSavedState:   'The saved state applies.',
    },

    users: {
      title:           'Users',
      subtitle:        'All users of this company',
      eyebrow:         'Settings · Users',
      add:             'Invite User',
      empty:           'No users available yet.',
      searchEmpty:     'No user found for «{search}».',
      name:            'Name',
      email:           'E-Mail',
      role:            'Role',
      status:          'Status',
      lastLogin:       'Last Login',
      data:            'User Data',
      emailHint:       'E-Mail cannot be changed after creation.',
      inviteHint:      'The user will receive an invitation e-mail to set their password.',
      roleAccess:      'Role & Access',
      internalNote:    'Internal Note',
      internalNotePH:  'Responsibilities, department …',
      noAccount:       'No login account available',
      noAccountHint:   'This user was created without a Firebase Auth account and cannot log in. Send an invitation e-mail to fix this.',
      inviteSent:      'Invitation sent!',
      inviteSentHint:  'An e-mail was sent to {email}. The user can use it to set their password.',
      deleteTitle:     'Delete User?',
      deleteConfirm:   'Do you really want to delete "{name}"? The user will immediately lose access.',
      invite:          'Send Invitation',
      invited:         'Invited',
      companies:       'Companies',
      companiesHint:   'The user sees and operates data in these companies.',
      // For the role `admin` this hint replaces the checkbox list
      // (REQ-SEC-030 prec. 1 (c), REQ-SEC-027 (a) — T-M38.4).
      companiesAdminHint: 'Administrators have access to all companies; no assignment is required.',
      companiesNone:   'Not assigned to any company yet.',
      companySearch:   'Search company …',
      companyNoMatch:  'No company found.',
      companyLimit:    'A user can have at most {max} companies. Please remove a company first.',
      companyRequired: 'Please select at least one company to invite into.',
      invitations:     'Open invitations',
      openInvitation:  'Open invitation',
      validUntil:      'Valid until {date}',
      expiredOn:       'Expired on {date}',
      reinvite:        'Invite again',
      inviteFailed:    'The invitation could not be sent.',
    },

    smtp: {
      title:            'E-Mail SMTP',
      subtitle:         'Settings for e-mail delivery',
      infoText:         'These SMTP settings are for custom e-mails. Firebase Auth sends system e-mails independently.',
      serverConnection: 'Server Connection',
      authentication:   'Authentication',
      sender:           'Sender',
      statusCard:       'Status',
      encryption:       'Encryption',
      lastSaved:        'Last saved',
      testSentTo:       'Test mail sent to {email}!',
      host:             'SMTP Host',
      port:             'Port',
      user:             'Username',
      password:         'Password',
      fromEmail:        'Sender E-Mail',
      fromName:         'Sender Name',
      secure:           'Use SSL / TLS',
      test:             'Send Test E-Mail',
      testSent:         'Test e-mail sent successfully!',
      save:             'Save SMTP Settings',
      noEncryption:     'No encryption (Port 25)',
      starttls:         'STARTTLS (Port 587)',
      tls:              'SSL/TLS (Port 465)',
      activeLabel:      'SMTP active',
      activeNotice:     'Invitation emails and system notifications are sent via this SMTP configuration.',
      activeFallback:   'If SMTP is not configured, Firebase Authentication is automatically used as a fallback.',
      secretBadge:      'Stored as a Firebase secret',
      secretHint:       'This secret is not kept in the database and is never loaded into the browser. It is set server-side in the Firebase project with the command below. Enter the value at the prompt or pipe it in with printf %s, never with echo: echo appends a line break, which is stored unchanged as part of the secret.',
    },

    api: {
      eyebrow:          'Settings · API',
      title:            'API Tokens',
      subtitle:         'Access tokens for the public REST API',
      tokensTitle:      'API Tokens',
      tokensSubtitle:   'Tokens for external API access — of this company and global',
      generate:         'Generate token',
      noCompany:        'Please select a company first.',
      empty:            'No API tokens yet.',
      colScope:         'Scope',
      scopeGlobal:      'Global',
      scopeCompany:     'Company',
      scopeGlobalHint:  'Valid for all companies.',
      scopeCompanyHint: 'Valid for this company only.',
      globalLabel:      'Global token',
      globalHint:       'Valid for all companies instead of this one only. Use it for internal access only and give it a name that identifies the user.',
      revokeGlobalHint: 'This token is valid for all companies. Once revoked, every company loses access through it immediately.',
      colName:          'Name',
      colPrefix:        'Prefix',
      colStatus:        'Status',
      colCreated:       'Created',
      colExpires:       'Valid until',
      colLastUsed:      'Last used',
      statusActive:     'Active',
      statusRevoked:    'Revoked',
      neverExpires:     'No expiry',
      revoke:           'Revoke token',
      tokenCreated:     'Token generated – save it now!',
      tokenOnceHint:    'The token is shown only once. Copy it to a safe place.',
      connectionTitle:  'Connection',
      authLabel:        'Authentication',
      contentTypeLabel: 'Content-Type',
      connectionNote:   'Send the token with every request in the Authorization header as a Bearer token.',
      createTitle:      'Generate a new API token',
      createBody:       'Optionally assign a name and an expiry date.',
      nameLabel:        'Name (optional)',
      namePlaceholder:  'e.g. Payfix integration',
      expiresLabel:     'Expiry date (optional)',
      expiresHint:      'Leave empty for a token that never expires.',
      revokeTitle:      'Revoke token?',
      revokeBody:       'The token "{name}" will be revoked irreversibly. All integrations using it will lose access immediately.',
      revokeConfirm:    'Yes, revoke',
    },
  },

  companySelect: {
    title:    'Select Company',
    subtitle: 'Please select a company to continue.',
    search:   'Search company …',
    empty:    'No companies found.',
    continue: 'Continue',
    notFound: 'No company found for "{query}"',
    // ⚠ ENTFALLEN AM 2026-08-22 (T-M24.3, REQ-OPS-058 (2)) — die vier Saetze
    // der Nachlade-Leiste (`limitReached`, `loadMore`, `loadedCount`,
    // `endOfList`) sind in allen sechs Sprachen zurueckgenommen; der deutsche
    // Wortlaut steht in `de.ts`. Die Firmen-Auswahl laedt alle Firmen auf
    // einmal. Die gleichnamigen Saetze unter `printers.*` bleiben stehen.
  },

  location: {
    offline: 'Location offline',
  },

  fastline: {
    cameraOpen:    'Open camera',
    orderNumber:   'Order number',
    search:        'Search',
    scan:          'Scan',
    scanQr:        'Scan QR code',
    // The touch keypad of the manual entry (REQ-SC-099, T-M23.3). It replaced
    // the three orphaned terminal texts on 2026-08-21.
    keypadOpen:      'Enter code',
    keypadTitle:     'Enter code manually',
    keypadHint:      'Fallback when the QR code cannot be read. Scanner and camera remain the regular way.',
    keypadSearch:    'Search order',
    keypadBackspace: 'Delete last character',
    // The two result screens (REQ-SC-100, T-M23.4). „Already picked up" is a
    // separate state and never this error (client decision of 2026-08-20).
    pickedUpTitle:     'Picked up',
    pickedUpDone:      'The order is completed and removed from the list.',
    pickedUpAutoClose: 'This window closes by itself in {seconds} seconds.',
    notFoundTitle:     'Order not found',
    notFoundText:      'This code is unknown.',
    notFoundRescan:    'Scan again',
    notFoundManual:    'Enter code manually',
    scanHint:      'Hold the QR code inside the frame',
    // Scan feedback moved to `screen.*` with T-M12.21 (REQ-SC-082).

    // The one main action of the pickup dialog (REQ-SC-098 (4), T-M23.2). It
    // replaced the six `handover*` texts on 2026-08-21.
    pickUp:        'Pick up',
    scannerReady:     'Scanner ready',
    scannerReadyHint: 'Scan the QR code on the receipt — the order opens by itself.',
  },

  kitchen: {
    toCook:           'To cook',
    tickets:          'Tickets',
    allDone:          'All done',
    openItems:        'Open items',
    open:             'Open',
    inProgress:       'In progress',
    start:            'Start',
    markReady:        'Ready',
    done:             'Done',
    emptyOpen:        'No open orders',
    emptyInProgress:  'No orders in progress',
    emptyReady:       'No orders ready for pickup',
    emptyOrders:      'No orders',
    doneAll:          'All done!',
    actionFailed:     'Not saved. Please tap again.',
    actionStale:      'The order has changed. The view updates by itself.',
    actionExpired:    'This screen’s session has expired. Please reload the page.',
    // Course grouping and course start (REQ-SC-068, T-M12.8). The course id
    // is a STRING and is used verbatim — `Course 2`, but also `Course Ürli`.
    gangLabel:        'Course {gang}',
    startGang:        'Start course',
    // Artikel-Countdown (REQ-SC-071): Aufschrift der Startschaltflaeche.
    timerStart:       '{minutes} min',
    // Subsequent changes (REQ-SC-072, T-M12.7): label of the red accept
    // button once the resulting quantity drops to zero or below.
    fullyCancelled:   'Fully cancelled',
    // QR pickup scan result dialog (REQ-SC-073, T-M12.10). The NAMED REASON
    // from REQ-SC-087 lives under `screen.scanNotReady` since T-M12.54 — it is
    // the same sentence on all three views.
    tableNumber:      'Table {number}',
    scanReceived:     'Received',
    scanNoDetail:     'Details of this order are not available on this screen.',
    // Card status of the Fastline view (REQ-SC-097 (2)) — display only; the
    // work status in Firestore stays `open`.
    waitingForPickupScan: 'Waiting for pickup scan',
  },

  screen: {
    keyPrompt:      'Enter display key',
    keyPlaceholder: 'Display key',
    connect:        'Connect',
    connecting:     'Connecting …',
    invalidKey:     'Invalid display key.',
    notPrinted:     'Receipt not yet printed',
    limitReached:   'Only the {count} most recent jobs are shown.',
    // Disabled screen view (REQ-SC-079, T-M12.19).
    viewDisabledTitle:       'This view is switched off',
    viewDisabledKitchenTv:   'Kitchen TV is not enabled for this channel.',
    viewDisabledAbholscreen: 'The pickup screen is not enabled for this channel.',
    viewDisabledChannel:     'Channel: {name}',
    viewDisabledHelp:        'You can enable the view for this channel under «Printers» in the dashboard.',
    // Screen mode takeover (REQ-SC-104 (5), T-M25.3) — exactly one mode is
    // active per channel; the newly opened screen names the active mode and
    // only writes once it is confirmed.
    modeNameNormal:   'Kitchen TV',
    modeNameLight:    'Kitchen TV Light',
    modeNameFastline: 'Fastline',
    takeoverTitle:    'Another mode is active',
    takeoverWarning:  'This channel is currently running «{active}». If you start «{own}» here, «{active}» will be switched off.',
    takeoverIdle:     'This screen has not taken over «{own}» yet.',
    takeoverConfirm:  'Start «{own}» here',
    takeoverRunning:  'Taking over …',
    takeoverHint:     'Nothing changes until you confirm – the other screen keeps running.',
    // QR pickup scan feedback (REQ-SC-082, T-M12.21) — shared by all three screens.
    alreadyPickedUp:       'Already picked up',
    alreadyPickedUpAt:     'Picked up on {time}',
    alreadyPickedUpNoTime: 'No time recorded',
    scanFound:             'Order found',
    scanCompleted:         'Completed',
    scanNotFound:          'No matching order found',
    scanError:             'Scan error',
    scanNotReady:          'The scan has been recorded. Completion only happens from «Ready for pickup».',
    // Number entry and scanner on the pickup screen (REQ-SC-012, T-M12.23).
    pickupPrompt: 'Enter or scan order number',
    pickupNumber: 'Order number',
    pickupSubmit: 'Pick up',
    // Bulk completion (REQ-SC-083, T-M12.22). The confirmation must name what
    // is completed and how many — and say explicitly that nothing is printed.
    completeAll:        'Complete all',
    completeAllTitle:   'Complete all orders?',
    completeAllBody:    '{count} orders in «In progress» and «Ready for pickup» will be completed. This clears the display: nothing is printed and no receipt is issued.',
    completeAllChunks:  'There are more than {max} orders. They are completed in {calls} steps; if a step fails, the orders of the later steps stay open.',
    completeAllConfirm: 'Yes, complete {count}',
    completeAllDone:    '{count} orders completed.',
    completeAllNoScan:  'Not picked up with a QR code: {count} orders carry no pickup scan. Complete them anyway?',
    // Origin label at a Fast Line channel (REQ-SC-095). "OrderMood" is a
    // proper name and stays untranslated in every language.
    originOrderMood: 'OrderMood',
    originRegister:  'POS',
  },

  // ── Das Kennzeichen des Testsystems (T-M32.7, REQ-OPS-061) ────────────────
  // Der Streifen am oberen Rand der Verwaltungsoberflaeche. Uebersetzt wird
  // allein das WORT „Testsystem"; `{projektId}` ist ein technischer Name und
  // steht in jeder Sprache gleich (REQ-OV-002, REQ-OV-008).
  // Der Emulator-Wortlaut ist der Sonderfall des lokalen Entwicklungswegs: dort
  // lautet die Projekt-ID `printerque-prod`, weil sie beim Emulatorlauf nur die
  // Audience der ID-Token ist (REQ-OPS-064 (a)) — ohne den Zusatz stuende ein
  // Widerspruch auf dem Bildschirm.
  umgebung: {
    testBanner:         'TEST SYSTEM · {projektId}',
    testBannerEmulator: 'TEST SYSTEM · {projektId} · Emulator',
  },
}
